import { render } from "./DisciplineFilter.vue?vue&type=template&id=316bc993&scoped=true&ts=true"
import script from "./DisciplineFilter.ts?vue&type=script&lang=ts&external"
export * from "./DisciplineFilter.ts?vue&type=script&lang=ts&external"

import "./DisciplineFilter.scss?vue&type=style&index=0&id=316bc993&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-316bc993"]])

export default __exports__